export class ChangePasswordModel 
{
    Password: string;
}